var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllstar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "allstar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboards-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Nav-Tray",
    transform: "translate(-873.000000, -57.000000)",
    fill: "#A28C62",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Tray",
    transform: "translate(853.000000, -61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(20.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "allstar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.59554166,23.9820918 C5.32163936,23.9820918 5.04964444,23.8966404 4.81751416,23.7287894 C4.38510716,23.4154039 4.18311374,22.8767548 4.30080016,22.356989 L5.90911783,15.272342 L0.454723593,10.4889703 C0.0537885885,10.1389628 -0.0993754039,9.58467302 0.0652330231,9.07749603 C0.229841401,8.57127268 0.677698363,8.21287265 1.2079549,8.16385255 L8.42478454,7.5086615 L11.2780607,0.831434635 C11.4884466,0.340851967 11.9675849,0.0240332344 12.4999396,0.0240332344 C13.0322942,0.0240332344 13.5114325,0.340851967 13.7218185,0.830290172 L16.5750946,7.5086615 L23.7907798,8.16385255 C24.3221808,8.21172824 24.7700377,8.57127268 24.9346462,9.07749603 C25.0992546,9.58371934 24.9470442,10.1389628 24.5461092,10.4889703 L19.091715,15.2713883 L20.7000327,22.3558446 C20.8179099,22.8767548 20.6157257,23.4154039 20.1835094,23.7278357 C19.7522468,24.0402674 19.1771664,24.0643006 18.7230151,23.791352 L12.4999396,20.0724989 L6.27686409,23.7934502 C6.06647812,23.9183847 5.83205897,23.9820918 5.59554166,23.9820918 Z M12.4999396,18.4704756 C12.7364569,18.4704756 12.9706853,18.5339919 13.181262,18.6589265 L19.05433,22.17159 L17.536423,15.4848261 C17.4280828,15.0089304 17.5896394,14.5120533 17.9573856,14.1900846 L23.10755,9.67336705 L16.2937534,9.05460726 C15.8031708,9.00978341 15.3812544,8.70135722 15.189561,8.24930396 L12.4999396,1.94802518 L9.80707561,8.2502577 C9.61748031,8.69925907 9.19556391,9.00768526 8.7061257,9.05250911 L1.89137548,9.6712689 L7.04134906,14.1879865 C7.41023974,14.5109089 7.5716056,15.0068323 7.46231173,15.4838724 L5.94554914,22.1704455 L11.8186171,18.6589265 C12.0290031,18.5339919 12.2634223,18.4704756 12.4999396,18.4704756 Z",
    id: "Shape"
  })))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllstar);
export default __webpack_public_path__ + "static/media/allstar.24287779b7179c4627eae1c3b2c94257.svg";
export { ForwardRef as ReactComponent };